'use client'

import type { ModelsClub } from '@/api/generated-api'
import {
  FacebookIcon,
  GlobeIcon,
  InstagramIcon,
  LinkIcon,
  TiktokIcon,
  XIcon,
  YoutubeIcon
} from '@/ui/icons/SocialIcons'

import S from './ClubSocialLinks.module.scss'

interface SocialItem {
  key: string
  label: string
  href?: string
  Icon: React.ComponentType
}

interface ClubSocialLinksProps {
  club: ModelsClub
}

const ClubSocialLinks = ({ club }: ClubSocialLinksProps) => {
  // OCE-562/584: backend field names standardized on `*_url`; Telegram is not
  // part of the contract any more. Removed legacy `*_link` fields.
  const items: SocialItem[] = [
    { key: 'tiktok', label: 'TikTok', href: club.tiktok_url, Icon: TiktokIcon },
    {
      key: 'youtube',
      label: 'YouTube',
      href: club.youtube_url,
      Icon: YoutubeIcon
    },
    {
      key: 'facebook',
      label: 'Facebook',
      href: club.facebook_url,
      Icon: FacebookIcon
    },
    {
      key: 'instagram',
      label: 'Instagram',
      href: club.instagram_url,
      Icon: InstagramIcon
    },
    { key: 'x', label: 'X', href: club.twitter_url, Icon: XIcon },
    {
      key: 'website',
      label: 'Website',
      href: club.website_url,
      Icon: GlobeIcon
    },
    // BAT-1228: the «Other» link of the profile form was never shown.
    { key: 'other', label: 'Other', href: club.other_url, Icon: LinkIcon }
  ]

  const visible = items.filter(i => Boolean(i.href))
  if (visible.length === 0) return null

  return (
    <div className={S.socialLinks}>
      {visible.map(({ key, label, href, Icon }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={S.socialLink}
          aria-label={label}
          title={label}
        >
          <Icon />
        </a>
      ))}
    </div>
  )
}

export default ClubSocialLinks
